module.exports = __webpack_public_path__ + "img/Roman.db3064e9.jpg";